function Accordion() {
	$('.js-accordion-button').on("click", function() {
		let $this = $(this);
		$this.toggleClass('is-active');
		$this.closest('.js-accordion').find('.js-accordion-block').slideToggle();
	});
}

export { Accordion };